import React from "react";
import { Icon, Dropdown } from "semantic-ui-react";
import { FacebookShareButton, TwitterShareButton, LinkedInShareButton } from "../SharingButtons";

function SharingDropdown({ trigger, url, campaignName = "case", eventSource = "post", content }) {
  return (
    <Dropdown trigger={trigger} pointing="top right" icon={null}>
      <Dropdown.Menu>
        <Dropdown.Item>
          <FacebookShareButton campaignName={campaignName} customUrl={url} eventSource={eventSource}>
            <Icon name="facebook official" />
            <span>Share to Facebook</span>
          </FacebookShareButton>
        </Dropdown.Item>
        <Dropdown.Item>
          <TwitterShareButton campaignName={campaignName} customUrl={url} eventSource={eventSource} tweetText={content}>
            <Icon name="twitter" />
            <span>Share to Twitter</span>
          </TwitterShareButton>
        </Dropdown.Item>
        <Dropdown.Item>
          <LinkedInShareButton campaignName={campaignName} customUrl={url} eventSource={eventSource}>
            <Icon name="linkedin" />
            <span>Share to LinkedIn</span>
          </LinkedInShareButton>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default SharingDropdown;



// WEBPACK FOOTER //
// ./src/components/SharingDropdown/index.js